import Command from './command';
import CommandResult from './command-result';
import BackspaceCommand from './command-result';
import Paragraph from '../types/paragraph';
import BlockRange from '../block-range';
export default Command.extend({
  processZeroWidth() {
    return this._insertAttribute();
  },
  processSingleBlock() {
    this._doBackspace();
    return this._insertAttribute();
  },
  processMultiBlock() {
    this._doBackspace();
    return this._insertAttribute();
  },
  _insertAttribute() {
    let attribute = this.get('options.attribute');
    this._addText(attribute);
    let entity = this._applyAttribute(attribute);
    this._selectAttribute(attribute);
    return CommandResult.create({
      attribute: entity,
      shouldRerender: true
    });
  },
  _addText() {
    let block = this.get('selection.firstSelectedPrimitiveBlock');
    let newText = Paragraph.create({
      config: block.get('config'),
      text: this.get('options.attribute.name')
    });
    let caretIndex = this.get('selection.startPositionIndex');
    block.insert(newText, caretIndex);
  },
  _applyAttribute(attribute) {
    let block = this.get('selection.firstSelectedPrimitiveBlock');
    let options = {
      fallback: '',
      identifier: attribute.get('templatable_identifier'),
      isApp: attribute.get('isApp'),
      noFallback: attribute.get('noFallback'),
      name: attribute.get('name'),
      isEventMetadata: attribute.get('isUserEventMetadata'),
      isSelectedEventMetadata: attribute.get('isSelectedEventMetadata'),
      isUser: attribute.get('isUser') && !attribute.get('isUserEvent'),
      isUserEvent: attribute.get('isUserEvent'),
      isCompany: attribute.get('isCompany')
    };
    let startIndex = this.get('selection.startPositionIndex');
    let endIndex = startIndex + attribute.get('name.length');
    let range = BlockRange.atPositionIndex(startIndex, endIndex);
    block.toggleEntity('attribute', range, options);
    return block.get('entities').byTypeWithinRange('attribute', range).pop();
  },
  _selectAttribute(attribute) {
    let startIndex = this.get('selection.startPositionIndex');
    let endIndex = startIndex + attribute.get('name.length');
    if (attribute.get('noFallback')) {
      startIndex = endIndex;
    }
    this.setSelectionToPositionIndex(startIndex, endIndex);
  },
  _doBackspace() {
    return BackspaceCommand.create({
      blockList: this.get('blockList'),
      selection: this.get('selection'),
      config: this.get('config')
    }).run();
  }
});